import { customRandom, urlAlphabet, random } from 'nanoid';
export const createPointId = customRandom(urlAlphabet, 10, random);
